<template>
  <BTable :fields="fields" :items="rows" hover striped>
    <template #map="{ item }">
      <a :href="mapUrl(item.properties.latlng)" target="_blank">{{
        item.properties.latlng
          ? item.properties.latlng.split(',').join(', ')
          : ''
      }}</a>
    </template>
  </BTable>
</template>

<script>
export default {
  name: 'JobStatusHistory',

  props: {
    rows: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      fields: [
        {
          key: 'datetime',
          label: this.$t('general.date'),
        },
        {
          key: 'description',
          label: this.$t('general.description'),
        },
        {
          key: 'map',
          label: this.$t('general.latlng'),
        },
      ],
    }
  },

  methods: {
    mapUrl(latlng) {
      if (latlng) {
        return 'https://www.google.com/maps/search/?api=1&query=' + latlng
      }
      return '#'
    },
  },
}
</script>
